import { render } from "./Footer1.vue?vue&type=template&id=aa16d55a&scoped=true"
import script from "./Footer1.vue?vue&type=script&lang=js"
export * from "./Footer1.vue?vue&type=script&lang=js"

import "./Footer1.vue?vue&type=style&index=0&id=aa16d55a&scoped=true&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa16d55a"]])

export default __exports__